<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
      <h3 class="text-lg font-semibold mb-4">{{ title }}</h3>

      <div class="mb-4">
        <p>{{ message }}</p>
        <p class="text-sm text-gray-500 mt-2">Это действие нельзя будет отменить.</p>
      </div>

      <div class="flex justify-end space-x-2">
        <button
          type="button"
          class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          @click="$emit('confirm')"
        >
          Удалить
        </button>
        <button
          type="button"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
          @click="$emit('cancel')"
        >
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Подтверждение' },
    message: { type: String, required: true },
    show: Boolean
  },
  mounted() {
    console.log('ConfirmationModal mounted');
  },
  emits: ['confirm', 'cancel']
};
</script>
